import React from 'react';

export default function HowItWorks({ steps }) {
  return (
    <section className="w-full bg-white py-12 text-center md:py-20">
      <h2 className="mb-12 text-3xl font-bold md:text-[40px]">How It Works</h2>
      <div className="flex flex-col items-center gap-6 md:flex-row md:justify-between md:gap-8">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex w-full max-w-xs flex-col items-center rounded-3xl bg-[#F4FBF9] p-6 text-center shadow-sm"
          >
            <img
              src={step.icon}
              alt={step.title}
              className="mb-4 h-16 w-16 md:h-20 md:w-20"
            />
            <h3 className="mb-2 font-bold md:text-[20px]">{step.step}</h3>
            <p className="text-[14px] text-gray-600 md:text-[16px]">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
